$(document).ready(function () {
    
    // Menu items now open on click only, not on hover.
    // Removed hover event listeners to ensure click-only behavior.

  
  // filter collection all page
  $('.filter-name-catelog-filter').click(function (e) {
    let targetId = $(this).attr('href').split('#')[1]; 
    let targetElement = $('#' + targetId);
  
    if (targetElement.length) {
      let scrollOffset = targetElement.offset().top;
      
      // Apply  only on mobile screens
      if ($(window).width() <= 768) {
        scrollOffset -= 100;
      }
  
      $('html, body').animate({ scrollTop: scrollOffset }, 500);
    }
  
    $(this).addClass('active').siblings().removeClass('active');
  });


});

function updateCartDrawer() {
  const _cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (!_cart || typeof _cart.renderContents !== 'function') return;
  
  const sections = (_cart.getSectionsToRender?.().map(s => s.id) || ['cart-drawer', 'cart-icon-bubble']).join(',');
  fetch(`/?sections=${sections}`)
    .then(res => res.json())
    .then(data => {
      const cart = window.cartJsCache || {};
      cart.sections = data;
      
      const quickAddModal = document.querySelector('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => _cart.renderContents(cart), { once: true });
        quickAddModal.hide(true);
      } else {
        _cart.renderContents(cart);
      }
      
      const drawer = document.querySelector('.drawer');
      if (drawer) {
        drawer.classList.remove("is-empty");
        drawer.classList.add("active");
      }
    })
    .catch(err => {
      console.error('Cart update error:', err);
      if (window.cartJsCache) _cart.renderContents(window.cartJsCache);
    });
}